import { Component, OnInit, NgModule } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormsModule, FormArray } from '@angular/forms';
import { CrudService } from './../../../crud/crud.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';
import { createAutoCorrectedDatePipe } from 'text-mask-addons';

import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import * as moment from 'moment';


@Component({
  selector: 'app-alumno-cambiar-formulario',
  templateUrl: './cambiar-grupo.component.html'
})

export class CambiarGrupoComponent implements OnInit{
  dato: FormGroup;

  titulo; mensaje; clase;

  grupo;
  carrera_plan;
  cargarDatosCatalogo = false;
  cambiarAll = true;

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private crud: CrudService, private notificacion: NotificationsService) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      carreras_planes_id: ['', [Validators.required]],
      periodos_escolares_id: ['', [Validators.required]],
      grupos_id: ['', [Validators.required]],
      carreras_planes_destino_id: [''],
      periodos_escolares_destino_id: ['', [Validators.required]],
      grupos_destino_id: ['', [Validators.required]],
      grupos: this.fb.array([]),
    });

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  detalleGrupo(id){
    this.dato.controls.grupos = this.fb.array([]);
    if (id!="") {
      this.cargarDatosCatalogo = true;
      this.crud.ver(id, "grupo").subscribe(
        resultado => {

          this.cargarDatosCatalogo = false;
          this.grupo = resultado.data;
          
          this.carrera_plan = resultado.data.carreras_planes;

          resultado.data.grupos_alumnos.forEach(element => {
            const grupo = <FormArray>this.dato.controls.grupos;
            // SE DEBE CAMBIAR EL CAMPO matricula A LA TABLA PERSONAS
            grupo.controls.push(
              this.fb.group(
                {
                  personas_id: [element.alumnos.id, [Validators.required]],
                  //nombre: [element.alumnos.alumnos_metadatos.apellido_paterno+' '+element.alumnos.alumnos_metadatos.apellido_materno+' '+element.alumnos.alumnos_metadatos.nombre],
                  nombre: [element.alumnos.nombre_completo],
                  cambiar: [1, [Validators.required]],
                }
              )
            )
          });
        },
        error => {
          this.cargarDatosCatalogo = false;
          this.titulo = "Sin resultados";
          this.mensaje = "No se encontro datos";
          this.clase = "warning";
          document.getElementById("message").click();
        }
      );
    }
  }

  checkAll(){
    this.dato.controls.grupos["controls"].forEach(element => {
      element.controls.cambiar.patchValue(this.cambiarAll);
    });
  }
}
